import axios from '../../config/axios';

export const profileApi = {
    getProfile: async () => {
        const response = await axios.get('/api/user');
        return response.data;
    },

    updateProfile: async (data) => {
        const response = await axios.put('/api/user', data);
        return response.data;
    },

    updateAvatar: async (data) => {
        const response = await axios.post('/api/user/avatar', data);
        return response.data;
    },

    updatePassword: async (data) => {
        const response = await axios.put('/api/user/password', data);
        return response.data;
    }
};
